import Vue from 'vue'
import moment from 'moment'
import numeral from 'numeral'

numeral.register('locale', 'pl', {
  delimiters: {
    thousands: ' ',
    decimal: '.'
  },
  abbreviations: {
    thousand: 'tys.',
    million: 'm',
    billion: 'b',
    trillion: 't'
  },
  currency: {
    symbol: 'zł'
  }
})

moment.locale('pl')
numeral.locale('pl')

Vue.filter('format_price', function (value) {
  return numeral(value).format('0,0.00 $')
})

Vue.filter('format_item_amount', function (value) {
  return numeral(value).format('0,0')
})

Vue.filter('format_datetime', function (value, format = 'L LT') {
  return moment(value).format(format)
})



// WEBPACK FOOTER //
// ./src/filters.js